<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-navbar-nav is-nav-bar class="d-md-down-none">
      <b-nav-item class="px-3"><router-link to="/report">Report</router-link></b-nav-item>
      <li class="nav-item px-3"><router-link to="/admin/companies" title="Companies">Companies</router-link></li>
      <!-- <b-nav-item class="px-3">Settings</b-nav-item> -->
    </b-navbar-nav>
    <b-navbar-nav is-nav-bar class="ml-auto">
      <li v-if="currentPage === 'Completion'" class="nav-item d-md-down-none">
        <a @click.prevent="toggleModeColumn()" href=""
          :title="titleColumn">
          <i :class="{'fa fa-columns': completionModeColumn === 1, 'fa fa-th-list': completionModeColumn !== 1}"></i>
        </a>
      </li>
      <li class="nav-item d-md-down-none">
        <a href="" @click.prevent="toggleSearchBox()" title="Search">
          <i class="fa fa-search"></i>
        </a>
      </li>
      <li class="nav-item d-md-down-none" v-if="impersonating">
        <a href="" title="Stop impersonation" class="text-danger" @click.prevent="stopImpersonate()"><i class="fa fa-user-secret fa-lg"></i></a>
      </li>
      <li class="nav-item d-md-down-none">
        <router-link to="/admin" title="Admin Area"><i class="fa fa-wrench"></i></router-link>
      </li>
      <b-nav-item class="d-md-down-none" @click.prevent="asideToggle">
        <i class="icon-bell"></i>
        <span v-if="notificationCount" class="badge badge-pill badge-danger">{{notificationCount}}</span>
      </b-nav-item>
      <b-nav-item-dropdown right>
        <template slot="button-content">
          <img :src="avatar" class="img-avatar" alt="avatar">
          <span class="d-md-down-none">{{fullName}}</span>
        </template>
        <!-- <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
        <b-dropdown-item><i class="fa fa-warning text-danger"></i> Alerts<span class="badge badge-danger">{{alertCount}}</span></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-bell-o text-info"></i> Updates<span class="badge badge-info">{{updateCount}}</span></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-envelope-o text-success"></i> Messages<span class="badge badge-success">{{messageCount}}</span></b-dropdown-item>
        <b-dropdown-item><i class="fa fa-file"></i> Reports<span class="badge badge-primary">{{reportCount}}</span></b-dropdown-item> -->
        <b-dropdown-header tag="div" class="text-center"><strong>Settings</strong></b-dropdown-header>
        <!-- <b-dropdown-item><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <b-dropdown-item><i class="fa fa-wrench"></i> Settings</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item><i class="fa fa-shield"></i> Lock Account</b-dropdown-item> -->
        <b-dropdown-item @click.prevent="goToProfile" v-b-modal.modal-center><i class="fa fa-user-circle"></i> User Profile</b-dropdown-item>
        <b-dropdown-item @click.prevent="logoutModal = true" v-b-modal.modal-center><i class="fa fa-lock"></i> Logout</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-modal title="Logout" v-model="logoutModal" class="modal-warning" hide-footer centered>
      Are you sure want to logout?
      <div class="modal-footer" style="margin-top:50px">
        <b-button variant="primary"  @click="logout" id="logoutBtn" :disabled="disabled">
          <span v-if="beforeLogout">YES</span>
          <span v-else> Loading..</span>
          <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
        </b-button>
      </div>
    </b-modal>
    <SearchBox
      @close-input="onCloseSearch"
      :isVisible="showSearchInput"/>
  </header>
</template>
<script>
import userMixin from '@/mixins/user';
import SearchBox from '@/components/SearchBox';

/* eslint-disable */
export default {
  name: 'header_el',
  components: {
    SearchBox,
  },
  mixins: [userMixin],
  data () {
    return {
      logoutModal: false, // FIXME use vuex
      showSearchInput: false,
      loadingSpinner: false,
      beforeLogout: true,
      disabled: false,
    }
  },
  created () {
    this.$store.dispatch('notifications/LOAD_DATA');
  },
  computed: {
    username () {
      return this.$store.getters.username
    },
    notificationCount() {
      return this.$store.getters['notifications/notifications'].length;
    },
    alertCount() {
      return this.$store.getters['notifications/alerts'].length;
    },
    messageCount() {
      return this.$store.getters['notifications/messages'].length;
    },
    reportCount() {
      return this.$store.getters['notifications/reports'].length;
    },
    updateCount() {
      return this.$store.getters['notifications/updates'].length;
    },
    fullName () {
      return this.$store.getters.userData.full_name
    },
    getId () {
      return this.$store.getters.userData.id
    },
    avatar () {
      return this.$store.getters.userData.avatar
    },
    impersonating () {
      return this.$store.getters.impersonating
    },
    minimizeSidebar () {
      return this.$store.getters.minimizeSidebar
    },
    completionModeColumn() {
      return this.$store.getters['shipment_md/shipments/completion_column'];
    },
    currentPage() {
      return this.$route.name;
    },
    titleColumn() {
      return this.completionModeColumn === 1 ? 'Set 2 column' : 'Set single column';
    },
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      if (this.minimizeSidebar) {
        this.$store.commit('RESTORE_SIDEBAR');
      } else {
        this.$store.commit('MINIMIZE_SIDEBAR');
      }
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logout () {
      // TODO: create modal confirmation
      this.loadingSpinner = true;
      this.beforeLogout = false;
      this.disabled = true;
      setTimeout(() => {
        this.$router.push('/logout')
      }, 2e3);
    },
    goToProfile () {
      this.$router.push(`/profile`)
    },
    onCloseSearch(closeTrue) {
      this.showSearchInput = closeTrue;
    },
    toggleModeColumn() {
      const count = this.completionModeColumn === 1 ? 2 : 1;
      this.$store.commit('shipment_md/shipments/SET_COULMN_COMPLETION', count);
    },
    toggleSearchBox() {
      setTimeout(() => {
        this.showSearchInput = !this.showSearchInput;
      }, 3e2);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue